import api from "../common/api/accountApi";

const basePath = "/accounts";

export default {
  turnOffDFP(accountId) {
    const account = { googleAuth: false };
    return api.put(`${basePath}/${accountId}`, account);
  },
  getFullList(
    params = {
      limit: 1000,
      sortBy: "name",
      sortOrder: "asc"
    }
  ) {
    return api.get(basePath, { params });
  },
  getList(params = {}) {
    return api.get(basePath, { params });
  },
  create(account) {
    return api.post(`${basePath}`, account);
  },
  get(accountId, params = {}) {
    return api.get(`${basePath}/${accountId}`, { params });
  },
  update(accountId, account) {
    return api.put(`${basePath}/${accountId}`, account);
  }
};



// WEBPACK FOOTER //
// ./src/services/accountService.js